import {
  TextField,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Stack,
} from "@mui/material"
import { DropzoneArea } from "mui-file-dropzone"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DateTimePicker } from "../ui/DateTimePickers"
import FormItem from "../ui/FormItem"
import Modal from "../ui/Modal"

const AddAssignmentModal = (props) => {
  return (
    <Modal {...props} title="Add Assignment" actionText="Add">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <FormItem label="Assignment name">
          <TextField />
        </FormItem>
        <FormItem label="Select batches">
          <FormGroup row>
            <FormControlLabel control={<Checkbox />} label="Batch 1" />
            <FormControlLabel control={<Checkbox />} label="Batch 2" />
          </FormGroup>
        </FormItem>
        <Stack direction="row" spacing={3} alignItems="center">
          <FormItem label="Total marks">
            <TextField type="number" />
          </FormItem>
          <FormItem label="Submission deadline">
            <DateTimePicker />
          </FormItem>
        </Stack>
        <FormItem label="Assignment file">
          <DropzoneArea
            acceptedFiles={["application/pdf"]}
            useChipsForPreview
          />
        </FormItem>
      </LocalizationProvider>
    </Modal>
  )
}

export default AddAssignmentModal
